import { useQuery } from '@tanstack/react-query'
import { useApiToken } from './useApiToken'
import { healthApi } from '../lib/api/health'

export function useSystemHealth() {
  const getToken = useApiToken()
  return useQuery({
    queryKey: ['system', 'health'],
    queryFn: async () => {
      const token = await getToken()
      return healthApi.getFull(token)
    },
    staleTime: 0,
    gcTime: 0,
  })
}
